<template>
  <o-tooltip
    variant="primary"
    label="Opens the csv upload page in a new tab"
  >
    <button
      :class="[
        'tw-flex tw-items-center tw-gap-2',
        'tw-p-3 tw-bg-white tw-shadow-sm tw-rounded-lg',
        'tw-text-[#F1583D] tw-font-medium tw-whitespace-nowrap',
        'tw-border tw-border-solid tw-border-[#DFE2E7] tw-cursor-pointer'
      ]"
      @click="openCsvUploadPage"
    >
      <i class="fa fa-file-csv tw-mr-1" />
      Upload CSV
    </button>
  </o-tooltip>
</template>
<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    openCsvUploadPage() {
      window.open('/advisordashboard/model_portfolio_upload/', '_blank noopener noreferrer');
    },
  },
};
</script>
